export default "__VITE_ASSET__CdeeHlJd__"